<template>
  <input-base
    :input="input"
    :review-mode="reviewMode"
    :error="error"
    class="form-wrapper-select"
  >
    <div
      class="flex-1 mt-2 -mx-4"
    >
      <label 
        v-for="(option, index) in input.attributes.options" 
        :key="input.key + '_' + index" 
        :tabindex="isDisabled ? -1 : 0"
        class="inline-flex items-baseline cursor-pointer p-4 w-1/2 focus:outline-none"
        :class="{
          'focus:shadow-outline': !isDisabled
        }"
        @keypress.space.prevent="handleLabel(option)"
      >
        <div
          class="border-2 w-4 h-4 flex mr-2 group-hover:border-primary-600 p-px"
          :class="{
            'border-grey-400': !selected(option),
            'border-primary-600': selected(option),
            'rounded-full' : input.type === 'radio'
          }"
        >
          <div
            class="w-full m-px rounded-sm"
            :class="{
              'bg-primary-600': selected(option),
              'group-hover:bg-primary-300': !selected(option),
              'rounded-full' : input.type === 'radio'
            }"
          />
        </div>
        <input 
          v-model="values" 
          :type="input.type" 
          :name="input.key"
          :value="option"
          :required="input.attributes.required"
          :readonly="input.attributes.locked"
          :disabled="isDisabled"
          class="hidden"
          @change="updateInput(parentField, input.key, values)"
        >
        {{ option }}
      </label>
    </div>
  </input-base>
</template>

<script>
import { inputHelperMixin } from "../../mixins/inputHelper";
export default {
  name: "InputMulti",
  mixins: [inputHelperMixin],
  data() {
    return {
      values: this.applicationValue
    }
  },
  computed: {
    isDisabled() {
      return this.input.attributes.locked || this.reviewMode
    },
    isCheckbox() {
      return this.input.type === 'checkbox'
    }
  },
  methods: {
    handleLabel(value) {
      if(this.isDisabled) return
      if(this.isCheckbox) {
        if(this.values.includes(value)) {
          this.values.splice(this.values.indexOf(value), 1)
        } else {
          this.values.push(value)
        }
      } else {
        this.values = value
      }
    },
    selected(value) {
      if(this.isCheckbox && Array.isArray(this.values)) {
        return this.values.includes(value)
      }
      return this.values === value;
    }
  }
};
</script>